module.exports = require("./dua.js");